import { useState, useEffect } from "react";
import NitroService from "../utils/nitro.service";
import {
  IFavoriteSetExtension,
  IGetFavoriteOriginsParams,
} from "../types/IFavoriteOrigins";
import { extendFavorites } from "../utils/extendFavorites";

export interface IFavoritesResponse {
  favorites: IFavoriteSetExtension[];
  loading: boolean;
  error: Error | null;
}

export const useFavoriteOrigins = (
  favoriteParams: IGetFavoriteOriginsParams,
  refetchTrigger?: number,
): IFavoritesResponse => {
  const [favoritesResponse, setFavoritesResponse] =
    useState<IFavoritesResponse>({
      favorites: [],
      loading: false,
      error: null,
    });

  useEffect(() => {
    if (!favoriteParams.marketer) {
      setFavoritesResponse({ favorites: [], loading: false, error: null });
      return;
    }

    setFavoritesResponse((prevData) => ({
      ...prevData,
      loading: true,
      error: null,
    }));

    const fetchData = async () => {
      try {
        const result = await NitroService.getFavoritesByMarketer(
          favoriteParams,
          0,
          0,
        );

        if (result.length === 0) {
          setFavoritesResponse({
            favorites: [],
            loading: false,
            error: null,
          });
          return;
        }
        const favorites = extendFavorites(result[0].favoriteSets);

        setFavoritesResponse({
          favorites,
          loading: false,
          error: null,
        });
      } catch (err) {
        setFavoritesResponse((d) => ({
          ...d,
          loading: false,
          error: err as Error,
        }));
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoriteParams, refetchTrigger]);

  return favoritesResponse;
};
